import { createSlice } from '@reduxjs/toolkit';
import { callbackStatuses } from '../../constants';

const initialState = {
  agentNum: null,
  cruiseLine: null,
  status: callbackStatuses.NOT_STARTED,
  statusLog: {},
  error: null,
};

const callbackSlice = createSlice({
  name: 'callback',
  initialState,
  reducers: {
    requestCallback: (state, { payload: { phone, cruiseLineObject } }) => ({
      ...state,
      agentNum: phone,
      cruiseLine: cruiseLineObject,
    }),
    updateStatus: (state, { payload: { newStatus, timeStamp } }) => {
      if (timeStamp) {
        return {
          ...state,
          status: newStatus,
          statusLog: { ...state.statusLog, [newStatus - 1]: timeStamp },
        };
      }
      return {
        ...state,
        status: newStatus,
      };
    },
    getCallbackError: (state, { payload: { error } }) => ({
      ...state,
      error,
      status: callbackStatuses.FAILURE,
    }),
  },
});

export const { requestCallback, updateStatus, getCallbackError } = callbackSlice.actions;

export default callbackSlice.reducer;
